"use client"

import type { FunctionComponent, PropsWithChildren } from "react"

import { useTranslation } from "@/modules/i18n/components/useTranslation"

export const InteractiveFilters: FunctionComponent<PropsWithChildren> = ({ children }) => {
  useTranslation(["job_ads_fo", "shared_modal", "shared_select_input"], true)

  return children
}
